import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MessagesModule } from 'primeng/messages';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderNavComponent } from './marketing/header-nav/header-nav.component';
import { FooterComponent } from './marketing/footer/footer.component';
import { LeftSideNavComponent } from './left-side-nav/left-side-nav.component';
import { HomeComponent } from './marketing/home/home.component';
import { AboutComponent } from './marketing/about/about.component';
import { ContactComponent } from './marketing/contact/contact.component';
import { LoginComponent } from './auth/login.component';
import { LoginPageComponent } from './auth/login-page.component';
import { ForgotPasswordComponent } from './auth/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password.component';
import { RegisterAgentComponent } from './auth/register-agent.component';
import { RegisterCustomerComponent } from './auth/register-customer.component';
import { IrrigationInsuranceComponent } from './marketing/irrigation-insurance/irrigation-insurance.component';
import { FormsComponent } from './marketing/forms/forms.component';
import { GetQuoteComponent } from './marketing/get-quote/get-quote.component';
import { UnimplementedRouteComponent } from './unimplemented-route/unimplemented-route.component';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { jwtAuthInterceptor } from './shared/interceptors/jwt-auth.interceptor';
import { authErrorInterceptor } from './shared/interceptors/auth-error.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HeaderNavComponent,
    FooterComponent,
    LeftSideNavComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    LoginComponent,
    LoginPageComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    RegisterAgentComponent,
    RegisterCustomerComponent,
    IrrigationInsuranceComponent,
    FormsComponent,
    GetQuoteComponent,
    UnimplementedRouteComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    RecaptchaModule,
    ToastrModule.forRoot({ timeOut: 15000 }),
    ModalModule.forRoot(),
    MessagesModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([jwtAuthInterceptor, authErrorInterceptor]),
    ),
  ],
})
export class AppModule {}
